import axios from "axios";
import oauth from "axios-oauth-client";
import { KEYCLOAK_TOKEN } from "./utilities";

export const getKeycloakAccessToken = oauth.ownerCredentials(
  axios.create(),
  process.env.REACT_APP_OAUTH_TOKEN, // OAuth 2.0 token endpoint
  "campaigns-app",
  null
);

const channelManagerUrl = `${process.env.REACT_APP_CHANNEL_MANAGER}`;

const restAgent_old = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_OLD,
  headers: {
    "Content-Type": "application/json",
  },
});

const restAgent_2 = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_2,
  headers: {
    "Content-Type": "application/json",
  },
});

const restAgent_new = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_NEW,
  headers: {
    "Content-Type": "application/json",
  },
});

export const keycloak_agent = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_NEW,
  headers: {
    "Content-Type": "application/json",
  },
});

// intercept keycloak oauth requests and generate new access token from keycloak in case of 401
keycloak_agent.interceptors.response.use(
  (response) => {
    return response;
  },
  async function (error) {
    const originalRequest = error.config;

    if (error && !originalRequest?._retry) {
      originalRequest._retry = true;

      const data = await getKeycloakAccessToken(
        "campaign-frontend",
        "password"
      );

      const access_token = data?.access_token;

      sessionStorage.setItem(KEYCLOAK_TOKEN, access_token);
      keycloak_agent.defaults.headers.common["Authorization"] =
        "Bearer " + access_token;

      originalRequest.headers.Authorization = "Bearer " + access_token;

      return keycloak_agent(originalRequest);
    }
    return Promise.reject(error);
  }
);

const socialRestAgent = axios.create({
  baseURL: process.env.REACT_SOCIAL_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const channelManagerAgent = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  baseURL: channelManagerUrl,
});

const getRequestConfig = () => {
  return { params: {}, headers: {} };
};

const Auth = {
  validateUser: (txId, appId) => {
    const config = getRequestConfig();
    config.params.txId = txId;
    config.params.id = appId;
    return restAgent_old.get(`auth/user/validate`, config);
  },
  getCompany: (appId) => {
    const config = getRequestConfig();
    config.params.id = appId;
    return restAgent_old.get(`v1/apps/company/details`, config);
  },
  getCampaignDetails: (appId) => {
    const config = getRequestConfig();
    config.params.id = appId;
    return restAgent_new.get(`v1/campaigns/details`, config);
  },
  getUserAccount: () => {},
  redirectToAuth: async () => {
    window.location.href = `${process.env.REACT_APP_AUTH}`;
  },
  redirectToSignIn: async () => {
    window.location.href = `${process.env.REACT_APP_SIGNIN}`;
  },
};

const Dashboard = {
  getSummary: (campaignId, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;
    config.params.campaignId = campaignId;
    return restAgent_new.get(`v1/campaigns/reports/summary`, config);
  },
  getRewards: (campaignId, startDate, endDate) => {
    const config = getRequestConfig();
    config.params.startDate = startDate;
    config.params.endDate = endDate;

    return restAgent_new.get(`v1/campaign/rewards/${campaignId}`, config);
  },
};

const Entries = {
  getEntries: (campaignId, page, limit, token) => {
    const config = getRequestConfig();
    // config.headers.Authorization = `Bearer ${KeycloakToken}`;
    config.params.campaignId = campaignId;
    config.params.page = page;
    config.params.limit = limit;
    return restAgent_new.get(`v1/campaigns/reports/all`, config);
  },
  getFilteredEntries: ({
    campaignId,
    page,
    limit,
    msisdn,
    rewardType,
    station,
    network,
    status,
    createdTo,
    createdFrom,
    transactionResult,
    channel,
    code,
    amount,
    token,
    signal,
  }) => {
    const config = getRequestConfig();
    // config.headers.Authorization = `Bearer ${token}`;
    config.params.campaignId = campaignId;
    config.params.page = page;
    config.params.limit = limit;
    config.params.msisdn = msisdn;
    config.params.rewardType = rewardType;
    config.params.station = station;
    config.params.status = status;
    config.params.network = network;
    config.params.amount = amount;
    config.params.code = code;
    config.params.channel = channel?.toUpperCase() || "";
    config.params["created-to"] = createdTo;
    config.params["created-from"] = createdFrom;
    config.params["transaction_result"] = transactionResult;
    return restAgent_new.get("v1/campaigns/reports/filter", {
      ...config,
      signal,
    });
  },
  exportEntries: ({
    campaignId,
    msisdn,
    rewardType,
    station,
    network,
    status,
    endDate,
    startDate,
    transactionResult,
    channel,
    code,
    emailRecipient,
  }) => {
    const config = getRequestConfig();

    config.params.campaignId = campaignId;
    config.params.msisdn = msisdn;
    config.params.rewardType = rewardType;
    config.params.station = station;
    config.params.status = status;
    config.params.network = network;
    config.params.code = code;
    config.params.channel = channel?.toUpperCase() || "";
    config.params["endDate"] = endDate;
    config.params["startDate"] = startDate;
    config.params["transaction_result"] = transactionResult;
    config.params["emailRecipient"] = emailRecipient;

    return restAgent_new.post(
      `v1/campaigns/reports/transactions/export`,
      null,
      config
    );
  },
  exportLeaderboard: ({ campaignId, endDate, startDate, emailRecipient }) => {
    const config = getRequestConfig();

    config.params.campaignId = campaignId;
    // config.params["endDate"] = endDate;
    // config.params["startDate"] = startDate;
    config.params["email"] = emailRecipient;

    return restAgent_new.post(
      `v1/campaigns/loyalty-points/leaderboard/csv`,
      null,
      config
    );
  },

  blockEntrant: (campaignId, msisdn, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;
    return restAgent_new.put(
      `v1/campaigns/users/block/${campaignId}/${msisdn}`,
      config
    );
  },

  getLeaderboard: ({
    campaignId,
    startDate,
    endDate,
    page,
    limit,
    access_token,
    signal,
  }) => {
    const config = getRequestConfig();
    config.params["startDate"] = startDate;
    config.params["endDate"] = endDate;
    config.params.page = page;
    config.params.pageSize = limit;
    config.signal = signal;

    if (access_token) {
      config.headers.Authorization = `Bearer ${access_token}`;
    }

    return keycloak_agent.get(
      `v1/campaigns/loyalty-points/top-rank?campaignId=65337a6a3017ebe468c6fdda`,
      config
    );
  },

  unBlockEntrant: (campaignId, msisdn, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;
    return restAgent_new.put(
      `v1/campaigns/users/unblock/${campaignId}/${msisdn}`,
      config
    );
  },

  getUserState: (campaignId, msisdn, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;
    return restAgent_new.get(
      `v1/campaigns/users/get-user-state/${campaignId}/${msisdn}`,
      config
    );
  },

  suspendEntrant: (campaignId, msisdn, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;

    return restAgent_new.put(
      `v1/campaigns/users/suspend/${campaignId}/${msisdn}?days=2`,

      config
    );
  },
  unSuspendEntrant: (campaignId, msisdn, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;

    return restAgent_new.put(
      `v1/campaigns/users/unsuspend/${campaignId}/${msisdn}?days=2`,

      config
    );
  },

  runDraw: (campaignId, drawData, token) => {
    const config = getRequestConfig();
    // config.headers.Authorization = `Bearer ${token}`;
    return restAgent_new.post(
      `v1/campaigns/draw/${campaignId}/run`,
      drawData,
      config
    );
  },

  getDrawWinners: (companyId, token, page, limit, createdTo, createdFrom) => {
    let config = getRequestConfig();
    // config.headers.Authorization = "Bearer " + token;
    config.params.page = page;
    config.params.limit = limit;
    config.params["endDate"] = createdTo;
    config.params["startDate"] = createdFrom;
    return restAgent_new.get(`v1/campaigns/draw/${companyId}/history`, config);
  },

  rewardDrawWinner: (companyId, payload, token) => {
    let config = getRequestConfig();
    // config.headers.Authorization = "Bearer " + token;

    return restAgent_new.post(
      `v1/campaigns/draw/${companyId}/reward`,
      payload,
      config
    );
  },
};

const Insights = {
  getDemographicDataSummary: (campaignId, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = "Bearer " + token;
    config.params.campaignId = campaignId;
    return restAgent_new.get(`v1/campaigns/reports/demographics`, config);
  },

  getInsights: (campaignId, startDate, endDate) => {
    const config = getRequestConfig();

    config.headers.Authorization = `Bearer ${token}`;
    config.params.startDate = startDate;
    config.params.endDate = endDate;
    config.params.type = "skus";

    return restAgent_new.get(`v1/campaigns/insight/${campaignId}`, config);
  },
  searchProductInsights: (campaignId, query) => {
    const config = getRequestConfig();

    // return restAgent.get(
    //   `v1/campaigns/insight/search/6348e5f63f6d725e514e6beb?type=product&query=${query}`,
    //   config
    // );
    return restAgent_new.get(
      `v1/campaigns/insight/search/${campaignId}?type=product&query=${query}`,
      config
    );
  },
  searchLocationInsights: (campaignId, query) => {
    const config = getRequestConfig();
    // return restAgent.get(
    //   `v1/campaigns/insight/search/6348e5f63f6d725e514e6beb?type=location&query=${query}`,
    //   config
    // );
    return restAgent_new.get(
      `v1/campaigns/insight/search/${campaignId}?type=location&query=${query}`,
      config
    );
  },
  getSKUInsights: (campaignId, startDate, endDate, query) => {
    const config = getRequestConfig();

    config.headers.Authorization = `Bearer ${token}`;
    config.params.startDate = startDate;
    config.params.endDate = endDate;
    config.params.type = "skus";
    config.params.products = query;

    // return restAgent.get(
    //   `v1/campaigns/insight/6348e5f63f6d725e514e6beb`,
    //   config
    // );
    return restAgent_new.get(`v1/campaigns/insight/${campaignId}`, config);
  },
  getLocationsInsights: (campaignId, startDate, endDate, query) => {
    const config = getRequestConfig();
    config.params.startDate = startDate;
    config.params.endDate = endDate;
    config.params.type = "location";
    config.params.locations = query;

    // return restAgent.get(
    //   `v1/campaigns/insight/6348e5f63f6d725e514e6beb`,
    //   config
    // );
    return restAgent_new.get(`v1/campaigns/insight/${campaignId}`, config);
  },
  getBrandsInsights: (campaignId, startDate, endDate) => {
    const config = getRequestConfig();
    config.params.startDate = startDate;
    config.params.endDate = endDate;
    config.params.type = "brands";

    return restAgent_new.get(`v1/campaigns/insight/${campaignId}`, config);
  },
  getBrandsPerLocationInsights: (campaignId, startDate, endDate, query) => {
    const config = getRequestConfig();
    config.params.startDate = startDate;
    config.params.endDate = endDate;
    config.params.type = "brands";
    config.params.locations = query;

    return restAgent_new.get(`v1/campaigns/insight/${campaignId}`, config);
  },
  getLocations: (campaignId, startDate, endDate) => {
    const config = getRequestConfig();
    config.params.startDate = startDate;
    config.params.endDate = endDate;
    config.params.type = "location";

    return restAgent_new.get(`v1/campaigns/insight/${campaignId}`, config);
  },
  getLocationPerBrand: (campaignId, startDate, endDate, query) => {
    const config = getRequestConfig();
    config.params.startDate = startDate;
    config.params.endDate = endDate;
    config.params.type = "location";
    config.params.brands = query;

    return restAgent_new.get(`v1/campaigns/insight/${campaignId}`, config);
  },
  getLocationSKU: (campaignId, startDate, endDate, locations, query) => {
    const config = getRequestConfig();

    config.headers.Authorization = `Bearer ${token}`;

    config.params.startDate = startDate;
    config.params.endDate = endDate;
    config.params.type = "locationskus";
    config.params.locations = locations;
    config.params.brands = query;

    return restAgent_new.get(`v1/campaigns/insight/${campaignId}`, config);
  },
  getSingleBrandInsight: (campaignId, startDate, endDate, query) => {
    const config = getRequestConfig();

    config.headers.Authorization = `Bearer ${token}`;
    config.params.startDate = startDate;
    config.params.endDate = endDate;
    config.params.type = "skus";
    config.params.brands = query;

    return restAgent_new.get(`v1/campaigns/insight/${campaignId}`, config);
  },
};

const Configs = {
  getRewardPackages: (campaignId) => {
    const config = getRequestConfig();
    config.params.campaignId = campaignId;
    return restAgent_new.get(`v1/campaign/rewards`, config);
  },
};

const Management = {
  getStations: (campaignId) => {
    const config = getRequestConfig();
    return restAgent_new.get(
      `v1/campaigns/promostation/get-all/${campaignId}`,
      config
    );
  },
  createStation: (token, data) => {
    const config = getRequestConfig();
    // config.headers.Authorization = `Bearer ${token}`;
    return restAgent_new.post(
      `v1/campaigns/promostation?campaignId=${data?.campaignId}`,
      data,
      config
    );
  },
  getStationById: (campaignId, stationId) => {
    const config = getRequestConfig();
    config.params["station-id"] = stationId;
    return restAgent_new.get(
      `v1/campaigns/promostation/get-by-id/${campaignId}`,
      config
    );
  },
  deleteStation: (campaignId, stationId) => {
    const config = getRequestConfig();
    config.params["station-id"] = stationId;
    return restAgent_new.delete(
      `v1/campaigns/promostation/${campaignId}`,
      config
    );
  },
  bulkAdd: (campaignId, data) => {
    const config = getRequestConfig();

    config.params["campaignId"] = campaignId;
    return socialRestAgent.post(
      `/api/v1/campaigns/promostation/bulk`,
      data,
      config
    );
  },
  editStation: (token, compaignId, stationId, data) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;
    return restAgent_new.put(
      `v1/campaigns/promostation/${compaignId}/${stationId}`,
      data,
      config
    );
  },
  activatePromoStation: (token, campaignId, stationId, data) => {
    const config = getRequestConfig();

    return restAgent_new.put(
      `/v1/campaigns/promostation/${campaignId}/${stationId}`,
      data,
      config
    );
  },

  getAgents: (campaignId) => {
    const config = getRequestConfig();
    return socialRestAgent.get(
      `/api/v1/campaigns/promoagent/get-all/${campaignId}`,
      config
    );
  },

  addAgent: (token, data) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;

    return restAgent_new.post(`v1/campaigns/promoagent`, data, config);
  },
  getAgentById: (campaignId, agentId) => {
    const config = getRequestConfig();
    config.params["agent-id"] = agentId;
    return restAgent_new.get(
      `v1/campaigns/promoagent/get-by-id/${campaignId}`,
      config
    );
  },

  editAgent: (token, campaignId, stationId, data) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;

    return restAgent_new.put(
      `v1/campaigns/promoagent/${campaignId}/${stationId}`,
      data,
      config
    );
  },

  deleteAgent: (campaignId, agentId) => {
    const config = getRequestConfig();
    config.params["agent-id"] = agentId;
    return restAgent_new.delete(
      `v1/campaigns/promoagent/${campaignId}`,
      config
    );
  },
};

const Settings = {
  updateUser: (userId, data) => {
    const config = getRequestConfig();
    // config.headers.Authorization = `Bearer ${token}`;
    config.params["userId"] = userId;
    config.params["name"] = data.name;
    config.params["email"] = data.email;
    return restAgent_2.put(`v1/users`, data, config);
  },

  updateCompany: (companyId, data) => {
    const config = getRequestConfig();
    // config.params["companyId"] = companyId;
    return restAgent_2.put(`v1/apps/${companyId}`, data, config);
  },

  inviteMembers: (campaignId, emails, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;

    return restAgent_2.post(
      `v1/apps/${campaignId}/roles?role=AGENT&contacts=${emails.join()}`,
      null,
      config
    );
  },

  getAllMembers: (campaignId, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;

    return restAgent_2.get(
      `v1/apps/${campaignId}/roles/all`,

      config
    );
  },

  updateMemberRole: (campaignId, email, role, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;
    config.params["role"] = role;
    config.params["email"] = email;

    return restAgent_2.put(`v1/apps/${campaignId}/roles`, null, config);
  },

  deleteMember: (campaignId, memberId, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;
    config.params["roleId"] = memberId;
    return restAgent_2.delete(
      `v1/apps/${campaignId}/roles`,

      config
    );
  },
};

const Reports = {
  DailyEntries: (campaignId, startDate, endDate) => {
    const config = getRequestConfig();
    config.params["campaignId"] = campaignId;
    config.params["startDate"] = startDate;
    config.params["endDate"] = endDate;

    return restAgent_new.get(
      `v1/campaigns/reports/daily-report-breakdown`,
      config
    );
  },

  stationPerformance: (campaignId, startDate, endDate) => {
    const config = getRequestConfig();
    config.params["campaignId"] = campaignId;
    config.params["startDate"] = startDate;
    config.params["endDate"] = endDate;

    return restAgent_new.get(
      `v1/campaigns/reports/station-report-breakdown`,
      config
    );
  },
  generalPerformance: (campaignId, startDate, endDate) => {
    const config = getRequestConfig();
    config.params["campaignId"] = campaignId;
    config.params["startDate"] = startDate;
    config.params["endDate"] = endDate;

    return restAgent_new.get(
      `v1/campaigns/reports/general-performance-report`,
      config
    );
  },
};

const reportBreakdown = {
  region: ({ campaignId, startDate, endDate, location, token }) => {
    const config = getRequestConfig();
    // config.headers.Authorization = `Bearer ${token}`;
    config.params["campaignId"] = campaignId;

    config.params["startDate"] = startDate;
    config.params["endDate"] = endDate;
    config.params["location"] = location;

    return restAgent_new.get(
      `v1/campaigns/reports/region-report-breakdown`,
      config
    );
  },
  gender: ({ campaignId, startDate, endDate, gender, token }) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;

    config.params["campaignId"] = campaignId;
    config.params["startDate"] = startDate;
    config.params["endDate"] = endDate;
    config.params["gender"] = gender;

    return restAgent_new.get(
      `v1/campaigns/reports/gender-report-breakdown`,
      config
    );
  },
  ageGroup: ({ campaignId, startDate, endDate, ageRange, token }) => {
    const config = getRequestConfig();
    // config.headers.Authorization = `Bearer ${token}`;

    config.params["campaignId"] = campaignId;
    config.params["startDate"] = startDate;
    config.params["endDate"] = endDate;

    config.params["ageRange"] = ageRange;

    return restAgent_new.get(
      `v1/campaigns/reports/age-report-breakdown/`,
      config
    );
  },

  fetchAgeGroups: (campaignId, token) => {
    const config = getRequestConfig();

    // config.headers.Authorization = `Bearer ${token}`;
    config.params["campaignId"] = campaignId;

    return restAgent_new.get(`v1/campaigns/reports/groupByAgeRange`, config);
  },
  // skuPerformance: ({ campaignId, startDate, endDate, location, token }) => {
  //   const config = getRequestConfig();
  //   config.params["campaignId"] = "6448fd9329b3cbd2f1b3f22e";
  //   // config.params["campaignId"] = campaignId;
  //   config.headers.Authorization = `Bearer ${token}`;
  //   // config.params["location"] = location;
  //   // config.params["startDate"] = startDate;
  //   // config.params["endDate"] = endDate;

  //   return restAgent_new.get(
  //     `v1/campaigns/reports/report-breakdown/products?startDate=2022-12-25&endDate=2023-01-01&location=Upper East`,
  //     config
  //   );
  // },
  reports: ({ campaignId, startDate, endDate, reportType, token }) => {
    const config = getRequestConfig();
    // config.headers.Authorization = `Bearer ${token}`;
    config.params["campaignId"] = campaignId;
    config.params["startDate"] = startDate;
    config.params["endDate"] = endDate;

    return restAgent_new.get(
      `v1/campaigns/reports/datarange/${campaignId}/${reportType}`,
      config
    );
  },
  productPerformance: ({ campaignId, startDate, endDate, token }) => {
    const config = getRequestConfig();
    // config.headers.Authorization = `Bearer ${token}`;
    config.params["campaignId"] = campaignId;
    config.params["startDate"] = startDate;
    config.params["endDate"] = endDate;

    return restAgent_new.get(
      `v1/campaigns/reports/datarange/promo/product`,
      config
    );
  },
  skuPerformance: ({ campaignId, startDate, endDate, token }) => {
    const config = getRequestConfig();
    // config.headers.Authorization = `Bearer ${token}`;
    config.params["campaignId"] = campaignId;
    config.params["startDate"] = startDate;
    config.params["endDate"] = endDate;

    return restAgent_new.get(
      `v1/campaigns/reports/datarange/promo/sku`,
      config
    );
  },
  fetchChannelPerformance: (campaignId, startDate, endDate) => {
    const config = getRequestConfig();

    // config.headers.Authorization = `Bearer ${token}`;
    config.params["campaignId"] = campaignId;
    config.params["startDate"] = startDate;
    config.params["endDate"] = endDate;

    return restAgent_new.get(
      `v1/campaigns/reports/datarange/promo/channel`,
      config
    );
  },
};

const Survey = {
  submitSurvey: (campaignId, data) => {
    const config = getRequestConfig();

    return restAgent_new.post(
      `v1/campaigns/insight/${campaignId}`,
      data,
      config
    );
  },

  visitCount: (campaignId) => {
    const config = getRequestConfig();
    config.params["campaignId"] = campaignId;

    return restAgent_new.get(`v1/campaigns/referrer/click`, config);
  },

  shareCount: (campaignId, channel) => {
    const config = getRequestConfig();

    return restAgent_new.get(
      `v1/campaigns/referrer/share/${campaignId}/${channel}`,
      config
    );
  },

  surveyResponse: (campaignId, page, limit, token) => {
    const config = getRequestConfig();
    config.params.page = page;
    config.params.limit = limit;
    config.headers.Authorization = "Bearer " + token;
    return restAgent_new.get(`v1/campaigns/survey/${campaignId}`, config);
  },
  filterSurveyResponse: ({
    campaignId,
    page,
    limit,
    msisdn,
    endDate,
    startDate,
    name,
    decoderNumber,
    token,
  }) => {
    const config = getRequestConfig();
    config.params.page = page;
    config.params.msisdn = msisdn;
    config.params.campaignId = campaignId;
    config.params.endDate = endDate;
    config.params.startDate = startDate;
    config.params.name = name;
    config.params.decoderNumber = decoderNumber;
    config.params.limit = limit;
    // config.headers.Authorization = "Bearer " + token;
    return restAgent_new.get(`v1/campaigns/survey/filter`, config);
  },
};

const SocialInteractions = {
  twitter: {
    fetchEntrants: (campaignId, retweet, like, reply, tweetUrl, token) => {
      const config = getRequestConfig();
      config.headers.Authorization = `Bearer ${token}`;
      // config.params["retweet"] = retweet;
      // config.params["like"] = like;
      // config.params["reply"] = reply;
      // config.params["tweetUrl"] = tweetUrl;

      return socialRestAgent.get(
        `twitter/fetchEntrants?campaignId=${campaignId}&retweet=${retweet}&like=${like}&reply=${reply}&tweetUrl=${tweetUrl}`,
        config
      );
    },

    sendMessage: (campaignId, recipientId, message, token) => {
      const config = getRequestConfig();
      config.headers.Authorization = `Bearer ${token}`;
      // config.params["recipientId"] = recipientId;
      // config.params["message"] = message;

      return socialRestAgent.post(
        `sendMessage?campaignId=${campaignId}&recipientId=${recipientId}&message=${message}`,
        config
      );
    },
    runDraw: (campaignId, data, token) => {
      const config = getRequestConfig();
      config.headers.Authorization = `Bearer ${token}`;

      return socialRestAgent.post(
        `/api/draw/twitter?campaignId=${campaignId}`,
        data,
        config
      );
    },
  },
};

const PointsSystem = {
  getUserPoints: (campaignId, userId, token) => {
    const config = getRequestConfig();
    config.headers.Authorization = `Bearer ${token}`;
    config.params.campaignId = campaignId;
    config.params.userId = userId;
    return restAgent_new.get(`v1/campaigns/loyalty-points`, config);
  },
};

const ChannelManagerServices = {
  fetchConnectedChannels: (companyId, token) => {
    let config = getRequestConfig();

    return channelManagerAgent.get(
      `/api/v1/channel/all/connected?agentId=${companyId}`,
      config
    );
  },
  disconnectChannel: ({ companyId, channelId, channelType, token }) => {
    let config = getRequestConfig();

    return channelManagerAgent.delete(
      `/api/v1/${channelType}/deactivate/${channelId}?agentId=${companyId}`,

      config
    );
  },
  fetchConnectedFacebookPages: ({ accessToken, agentId, token }) => {
    let config = getRequestConfig();

    return channelManagerAgent.post(
      `/api/v1/messenger/connected/facebook/pages`,
      { accessToken, agentId },
      config
    );
  },
  channelManagerServiceRegistration: ({
    channel_access_token,
    channelType,
    appId,
    token,
  }) => {
    let config = getRequestConfig();
    config.params.experience = "CAMPAIGNS";

    return channelManagerAgent.post(
      `/api/v1/${channelType}/activate`,
      { accessToken: channel_access_token, appId },
      config
    );
  },
  disconnectSocialChannel: ({ channelId, companyId, token }) => {
    let config = getRequestConfig();

    return channelManagerAgent.delete(
      `/api/v1/messenger/deactivate/${channelId}?agentId=${companyId}`,
      config
    );
  },
};

export default {
  Auth,
  Management,
  Entries,
  Dashboard,
  Configs,
  Settings,
  Reports,
  Insights,
  Survey,
  SocialInteractions,
  PointsSystem,
  reportBreakdown,
  ChannelManagerServices,
};
